import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  holiday_add_action,
  holiday_detail_action,
} from "../../../actions/master_actions/holiday_action";
import moment from "moment";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { DaysActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillList_action";
import Header from "../../../common_components/Header";

const CustomInput = forwardRef(({ value, onClick, disabled }, ref) => (
  <input
    type="text"
    className="form-control"
    value={value}
    onClick={onClick}
    onChange={() => {}}
    disabled={disabled}
    // readOnly // Prevent manual typing
    ref={ref}
  />
));

class HolidaysAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isSystemExpanded: false,
      userId: "",
      HolidayID: "",
      Name: "",
      Date: "",
      Day: "",
      daysList: [],
      CreatedBy: "",
      CreatedDate: "",
      ModifiedBy: "",
      ModifiedDate: "",
      DeletedBy: "",
      DeletedDate: "",
      StatusID: 0,
      NameErr:"",
      DateErr:""
    };

    this.holidayDetails = this.holidayDetails.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.backToHoliday = this.backToHoliday.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    console.log(this.props.location.state?.HolidayID, "state");

    const HolidayID = this.props.location.state?.HolidayID || "";
    console.log("HolidayID:", HolidayID);

    if (HolidayID) {
      this.setState({ HolidayID }, () => {
        this.holidayDetails();
      });
    }
    this.getFillList(DaysActionId, userId, "", "");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        console.log(data, "daysFillList");
        if (data.error != 1) {
          if (value == DaysActionId) {
            this.setState({ daysList: data.data, isLoading: false });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  
  inputValidate(){
    const {Name,Date}=this.state
    if(Name===""){
      this.setState({NameErr:'Please enter Holiday Name'})
    }
    if(Date===""||Date==null){
      this.setState({DateErr:'Please Select Date'})
    }
  }

  handleUpdate() {
    const { userId, HolidayID, Name, Date, Day, StatusID } = this.state;
    const finalStatus = StatusID ? 1 : 0;
    console.log(userId, HolidayID, Name, Date, Day);
    setTimeout(() => {
      this.inputValidate()
  }, 100);
    if (Name == "" || Name == null) {
      toast.error("Kindly Fill Holiday Name", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else if (Date == "" || Date == null) {
      toast.error("Kindly Select Date", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    
    } else {
      this.setState({ isLoading: true });
      console.log(HolidayID, Name, Date, Day);
      this.props
        .holiday_add_action(HolidayID, Name, Date, Day, finalStatus)
        .then((data) => {
          if (data.error !== 1) {
            this.setState({ isLoading: false }, () => {
              toast.success(
                HolidayID
                  ? "Holiday Updated Successfully"
                  : "Holiday Added Successfully",
                {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                }
              );
              setTimeout(() => {
                this.backToHoliday();
              }, 1000); // Adjust the delay time as needed
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  backToHoliday() {
    this.props.navigate("/holidays");
  }
  holidayDetails() {
    const { HolidayID } = this.state;
    this.props
      .holiday_detail_action(HolidayID)
      .then((data) => {
        console.log("holiday details--------", data);
        if (data.error !== 1) {
          this.setState({
            Name: data.data[0]["Name"],
            Date: moment(data.data[0]["Date"]).toDate(),
            Day: data.data[0]["Day"],
            CreatedBy: data.data[0]["CreatedBy"],
            CreatedDate: data.data[0]["CreatedDate"],
            ModifiedBy: data.data[0]["ModifiedBy"],
            ModifiedDate: data.data[0]["ModifiedDate"],
            DeletedBy: data.data[0]["DeletedBy"],
            DeletedDate: data.data[0]["DeletedDate"],
            StatusID: data.data[0]["StatusID"],
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          this.setState({ isLoading: false });
          toast.error(data.data, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const {
      isLoading,
      Name,
      Date,
      Day,
      daysList,
      HolidayID,
      isSystemExpanded,
      CreatedBy,
      CreatedDate,
      ModifiedBy,
      ModifiedDate,
      DeletedBy,
      DeletedDate,
      StatusID,NameErr,DateErr
    } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[15]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">
                    {HolidayID ? "Edit" : "Add"} Holiday
                  </h4>
                  <div class="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">
                      {HolidayID?StatusID == 1 ? "Active" : "Inactive":"Active"}
                    </h6>
                    <div class="checkbox checbox-switch">
                      <label class="switch">
                        {HolidayID?(
                             <>
                         
                             <input
                               type="checkbox"
                               checked={StatusID}
                               onChange={() => {
                                 this.setState((prevState) => ({
                                   StatusID: !prevState.StatusID,
                                 }));
                               }}
                             />
                             <span class="slider round"></span>
                             </>

                        ):(
                          <>
                          <input
                                                    type="checkbox"
                                                    checked={1}
                                                   
                                                  />
                                                  <span class="slider round"></span></>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card Service_fields">
                  <div className="card-body">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label htmlFor="inputZip">
                          Holiday <span className="mendatory_class">*</span>{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="fname"
                          maxLength={50}
                          onChange={(e)=>this.setState({Name:e.target.value,NameErr:""})}
                          name="Name"
                          value={Name}
                        />{<span className='text-danger text-start text-left d-block mt-1'>{NameErr}</span>}
                      </div>
                      <div className="form-group col-md-2">
                        <label htmlFor="inputZip">
                          Date <span className="mendatory_class">*</span>{" "}
                        </label>
                        <DatePicker
  className="form-control"
  dateFormat="dd-MM-yyyy"
  selected={this.state.Date}
  onChange={(date) => {
    this.setState({ Date: date,DateErr:'' }, () => {
      const dayAbbreviation = date.toString().split(' ')[0];
      console.log(dayAbbreviation);
      this.setState({Day:dayAbbreviation})
      // Now you have the abbreviated day, such as "Tue"
    });
  }}
  peekNextMonth
  showMonthDropdown
  showYearDropdown
  dropdownMode="select"
  placeholderText="Holiday Date"
  customInput={<CustomInput />}
  dayClassName={() => "example-datepicker-day-class"}
  popperClassName="example-datepicker-class"
/>{<span className='text-danger text-start text-left d-block mt-1'>{DateErr}</span>}

                      </div>
                      <div className="form-group col-md-2">
                        <label htmlFor="inputZip">
                          Day<span className="mendatory_class">*</span>
                        </label>
                        <select
                          className="form-control search_form_control"
                          value={this.state.Day}
                        disabled
                        >
                          <option value="">Select</option>
                          <option value="Mon">MONDAY</option>
                          <option value="Tue">TUESDAY</option>
                          <option value="Wed">WEDNESDAY</option>
                          <option value="Thu">THURSDAY</option>
                          <option value="Fri">FRIDAY</option>
                          <option value="Sat">SATURDAY</option>
                          <option value="Sun">SUNDAY</option>
                        </select>
                      </div>
                    </div>
                    {HolidayID ? (
                      <div
                        className="system_info"
                        aria-expanded={isSystemExpanded}
                        onClick={() =>
                          this.setState({
                            isSystemExpanded: !isSystemExpanded,
                          })
                        }
                      >
                        <div className="row row_margin collpase_arrow_cursor">
                          <div className="col-md-6 col-sm-6 col-7">
                            <span
                              data-toggle="collapse"
                              data-target="#Sys_info"
                              className=""
                            >
                              <i
                                className={
                                  isSystemExpanded
                                    ? "fa fa-chevron-down CRM_rotate_data"
                                    : "fa fa-chevron-right CRM_rotate_data"
                                }
                                style={{ fontSize: 12, color: "#898989" }}
                              />
                              <span
                                className="heading_text"
                                style={{ paddingLeft: 5 }}
                              >
                                System Info
                              </span>
                            </span>
                          </div>
                          <div className="col-md-6 col-sm-6 col-5 text-right">
                            {/* <span style="color:#10c5e3;position: relative;top: -3px;right: 3px; display:none;"></span>
            <i class="fa fa-plus-circle" data-toggle="modal" data-target="#Add_new_trade_modal" style="font-size: 20px;cursor:pointer;line-height:20px;color: #898989;"></i> */}
                          </div>
                        </div>
                        <hr
                          style={{
                            marginTop: 0,
                            marginBottom: 15,
                            border: "1px solid #c0c0c0",
                          }}
                        />
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${
                            isSystemExpanded ? "show" : ""
                          }`}
                          aria-labelledby="headingOne"
                        >
                          <div className="form-group">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Created By
                                  </label>
                                  <p className="Sys_info_style">
                                    {CreatedDate != null
                                      ? CreatedBy
                                      : "Not Available"}
                                  </p>
                                </div>
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Created Date
                                  </label>
                                  <p className="Sys_info_style">
                                    {CreatedDate != ""
                                      ? moment(CreatedDate).format("DD-MM-YYYY")
                                      : ""}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Modified By
                                  </label>
                                  <p className="Sys_info_style">
                                    {ModifiedDate != null
                                      ? ModifiedBy
                                      : "Not Available"}
                                  </p>
                                </div>
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Modified Date
                                  </label>
                                  <p className="Sys_info_style">
                                    {ModifiedDate != null
                                      ? moment(ModifiedDate).format(
                                          "DD-MM-YYYY"
                                        )
                                      : "Not Available"}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Deleted By
                                  </label>
                                  <p className="Sys_info_style">
                                    {DeletedDate != null
                                      ? DeletedBy
                                      : "Not Available"}
                                  </p>
                                </div>
                                <div className="form-group">
                                  <label
                                    className="sys_info_label"
                                    htmlFor="email"
                                  >
                                    Deleted Date
                                  </label>
                                  <p className="Sys_info_style">
                                    {DeletedDate != null
                                      ? moment(DeletedDate).format("DD-MM-YYYY")
                                      : "Not Available"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="row">
                      <div>
                        <a
                          href="javascript:void(0);"
                          className="btn save_btn"
                          onClick={() => {
                            this.handleUpdate();
                          }}
                        >
                          {HolidayID ? "Update" : "Save"}
                        </a>
                      </div>
                      <div className="mx-2">
                        <a
                          href="javascript:void(0);"
                          onClick={() => {
                            this.backToHoliday();
                          }}
                          className="btn back_btn"
                        >
                          Back
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    holiday_add_action,
    holiday_detail_action,
    fill_action,
  })(HolidaysAdd)
);
